import React, { useEffect, useState } from "react";
import _ from "lodash";
import Socket from "socket";
import icon1 from "assets/images/dw20/icon.svg";
import icon2 from "assets/images/dw20/Dw20-Flip-icon.png";
import { motion } from "framer-motion/dist/framer-motion";
import {
  divVariants,
  staticBounceVariants
} from "shared/components/animations";
const DWReadingCzar = ({
  roomId,
  playedCard,
  isReading = false,
  isEvaluating = false,
  onEvaluateCard = () => {},
  buzzer_sound,
  default_audio_effect
}) => {
  const [flippedArray, setFlippedArray] = useState([]);
  const allCardsFlipped = playedCard?.every((item) => item.flipped);
  useEffect(() => {
    const array = playedCard?.map((item) => ({
      cardId: item.card.id,
      flipped: false,
      opacityValue: 1
    }));
    setFlippedArray([...array]);
  }, []);

  const calculateOpacity = (id) => {
    setTimeout(() => {
      const array = flippedArray.map((item) =>
        item.cardId === id ? { ...item, opacityValue: 0 } : item
      );
      setFlippedArray([...array]);
    }, 800);
  };

  const handleFlipCard = (id) => {
    const array = flippedArray.map((item) =>
      item.cardId === id
        ? { ...item, flipped: true, opacityValue: calculateOpacity(id) }
        : item
    );
    setFlippedArray([...array]);
    const data = {
      action: "flip-card",
      roomId: roomId,
      cardId: id
    };
    Socket.sendMessage(data);
  };
  
  useEffect(() => {
    if (isReading && allCardsFlipped) {
      updateRoomForEvaluation();
    }
  }, [isReading, allCardsFlipped]);
  const updateRoomForEvaluation = () => {
    const data = {
      action: "update-status",
      roomId: roomId
    };
    setTimeout(() => {
      Socket.sendMessage(data);
    }, 2000);
  };
  useEffect(() => {
    if (isEvaluating && allCardsFlipped && !_.isEmpty(default_audio_effect)) {
      buzzer_sound();
    }
  }, [buzzer_sound, isEvaluating, allCardsFlipped, default_audio_effect]);

  return (
    <motion
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="slide-cards"
    >
      {playedCard?.map((item, index) =>
        item.flipped ? (
          <motion.div
            variants={staticBounceVariants}
            className="card"
            key={`${index}-${item.flipped}`}
            onClick={() => onEvaluateCard(item.card)}
          >
            <p className="long-text">{item?.card?.text}</p>
            <p className="hash-left">#DoneWith2020</p>
            <div className="icon-right">
              <img src={icon1} className="img-fluid" alt="" />
            </div>
          </motion.div>
        ) : (
          <motion.div
            variants={staticBounceVariants}
            className="card"
            key={index}
            onClick={() => handleFlipCard(item.card.id)}
          >
            <h2 className="title">Done with 2020</h2>
            <div className="icon-right">
              <img src={icon2} className="img-fluid" alt="" />
            </div>
          </motion.div>
        )
      )}
    </motion>
  );
};

export default DWReadingCzar;
